import React from 'react';
import '../../styles/common.css';
import styles from './PublicOffer.module.css';
import Contacts from '../Contacts/Contacts';

const PublicOffer = () => {
  const sections = [
    {
      id: 1,
      title: '1. Общие положения и предмет договора',
      items: [
        {
          number: '1.1',
          text: 'Настоящая Публичная оферта (далее — «Оферта») является официальным предложением Плательщика налога на профессиональный доход (самозанятого) Сопова Артема Игоревича (далее — «Исполнитель») заключить договор оказания цифровых услуг на условиях, изложенных ниже.'
        },
        {
          number: '1.2',
          text: 'Исполнитель оказывает Заказчику (Пользователю) цифровые услуги по предоставлению доступа к функциональным возможностям, сервисам и игровой инфраструктуре проекта Interworld, включая услугу по автоматическому зачислению на аккаунт Заказчика внутриигровой расчетной единицы (внутриигровой валюты), используемой внутри игровых серверов проекта.'
        },
        {
          number: '1.3',
          text: 'Приобретаемая Заказчиком внутриигровая валюта используется исключительно внутри игровой системы проекта Interworld для доступа к дополнительному виртуальному функционалу, статусам и цифровым элементам на серверах Исполнителя. Внутриигровая валюта не является денежным средством, электронными денежными средствами, ценной бумагой или имуществом и не подлежит обмену на реальные денежные средства.'
        },
        {
          number: '1.4',
          text: 'Заказчик также вправе совершить добровольный безвозмездный взнос на развитие и поддержку проекта Interworld через специальный раздел сайта. Данный взнос признается дарением (ст. 572 ГК РФ), совершается без получения какого-либо встречного предоставления со стороны Исполнителя (цифровых услуг, валюты) и не подлежит возврату, за исключением случаев, прямо предусмотренных законодательством Российской Федерации.'
        },
        {
          number: '1.5',
          text: 'Акцептом (полным и безоговорочным принятием) настоящей Оферты является совершение Заказчиком действий по оплате Услуг или внесению безвозмездного взноса через уполномоченную платежную систему (Robokassa).'
        },
        {
          number: '1.6',
          text: 'Осуществляя акцепт настоящей Оферты, Заказчик подтверждает, что: Он является совершеннолетним и полностью дееспособным физическим лицом, либо несовершеннолетним лицом, получившим прямое согласие своих законных представителей (родителей, усыновителей, попечителей) на совершение сделки в соответствии со ст. 26 и 28 ГК РФ. Полностью ознакомился и согласен с условиями настоящей Оферты и Правилами игровых серверов Interworld, постоянно доступными по адресу: https://interworld.fun/server-rules.'
        }
      ]
    },
    {
      id: 2,
      title: '2. Цены и порядок оплаты',
      items: [
        {
          number: '2.1',
          text: 'Стоимость оказываемых Услуг и объем зачисляемой внутриигровой валюты указаны на официальном сайте проекта на странице https://interworld.fun/donate#buy-status.'
        },
        {
          number: '2.2',
          text: 'Исполнитель вправе в одностороннем порядке изменять стоимость Услуг. К уже оплаченным и зачисленным заказам применяются цены, действовавшие непосредственно в момент совершения оплаты.'
        },
        {
          number: '2.3',
          text: 'Оплата Услуг производится в безналичном порядке в рублях РФ через уполномоченный платежный сервис Robokassa. Кассовый чек в соответствии с ФЗ № 422-ФЗ формируется и направляется Заказчику в электронном виде.'
        }
      ]
    },
    {
      id: 3,
      title: '3. Порядок оказания услуг и зачисления валюты',
      items: [
        {
          number: '3.1',
          text: 'Услуга считается полностью и надлежащим образом оказанной Исполнителем в момент автоматического зачисления приобретенной внутриигровой валюты на учетную запись (никнейм) Заказчика на выбранном игровом сервере. С момента зачисления обязательства Исполнителя по оказанию Услуги считаются выполненными в полном объеме (ст. 408 ГК РФ).'
        },
        {
          number: '3.2',
          text: 'Автоматическое зачисление происходит в течение нескольких минут (но не более 24 часов в случае возникновения технических задержек) после получения подтверждения об успешной оплате от платежной системы.'
        },
        {
          number: '3.3',
          text: 'Заказчик несет личную ответственность за корректность указанного им никнейма и выбор игрового сервера при оформлении заказа. Исполнитель не несет ответственности за последствия предоставления Заказчиком недостоверных сведений, однако вправе оказать содействие в переносе баланса при обращении в службу поддержки.'
        },
        {
          number: '3.4',
          text: 'Оказываемые Услуги носят исключительно цифровой характер и не требуют физической доставки на материальном носителе.'
        }
      ]
    },
    {
      id: 4,
      title: '4. Игровая механика, сбросы (вайпы) и сохранность данных',
      items: [
        {
          number: '4.1',
          text: 'Внутриигровая валюта, а также активированные с ее помощью статусы и виртуальные предметы привязываются к учетной записи (никнейму) Заказчика.'
        },
        {
          number: '4.2',
          text: 'Исполнитель оставляет за собой право проводить плановые и технические обновления, изменение баланса игры, а также частичные или полные сбросы игрового мира (вайпы).'
        },
        {
          number: '4.3',
          text: 'Проведение плановых вайпов игрового мира не затрагивает неиспользованную внутриигровую валюту, а также действующие постоянные статусы Заказчика — данные привилегии и баланс сохраняются за учетной записью Заказчика.'
        }
      ]
    },
    {
      id: 5,
      title: '5. Права и обязанности сторон',
      items: [
        {
          number: '5.1',
          text: 'Исполнитель обязуется: Предоставить Услугу по зачислению внутриигровой валюты в соответствии с условиями Оферты; Обеспечить базовую техническую поддержку Заказчиков через официальные каналы связи проекта.'
        },
        {
          number: '5.2',
          text: 'Заказчик обязуется: Соблюдать законодательство Российской Федерации и Правила игровых серверов Interworld; Не использовать стороннее ПО (читы, модификации), уязвимости (баги) игры и нечестные способы получения преимущества; Не передавать доступ к своей учетной записи третьим лицам и не осуществлять продажу внутриигровых ценностей за реальные деньги.'
        },
        {
          number: '5.3',
          text: 'Дисциплинарные санкции и блокировка (бан): В случае нарушения Заказчиком Правил серверов, Исполнитель вправе применить к Заказчику дисциплинарные меры, включая временную или бессрочную блокировку (бан) доступа к игровым серверам. Платная услуга по разблокировке (разбану) аккаунта Исполнителем не оказывается. Заказчик имеет право обжаловать блокировку, направив обращение в службу поддержки проекта. Применение блокировки за доказанное нарушение Правил сервера является следствием неисполнения Заказчиком п. 5.2 настоящей Оферты и осуществляется поскольку услуга считается исполненной в соответствии с разделом 3 настоящей Оферты.'
        }
      ]
    },
    {
      id: 6,
      title: '6. Ответственность сторон',
      items: [
        {
          number: '6.1',
          text: 'За неисполнение или ненадлежащее исполнение обязательств по настоящей Оферте Стороны несут ответственность в соответствии с действующим законодательством РФ.'
        },
        {
          number: '6.2',
          text: 'Исполнитель не несет ответственности за временные перебои в работе серверов, вызванные техническими работами, сбоями на стороне хостинг-провайдеров, магистральных интернет-каналов или DDoS-атаками третьих лиц, при условии принятия разумных мер по их устранению.'
        }
      ]
    },
    {
      id: 7,
      title: '7. Порядок возврата денежных средств',
      items: [
        {
          number: '7.1',
          text: 'В соответствии со ст. 32 Закона РФ «О защите прав потребителей» и ст. 782 ГК РФ, потребитель вправе отказаться от исполнения договора до момента его фактического исполнения.'
        },
        {
          number: '7.2',
          text: 'После полного оказания услуги возврат денежных средств производится только в случаях, предусмотренных законодательством Российской Федерации.'
        },
        {
          number: '7.3',
          text: 'Если зачисление внутриигровой валюты не произошло в течение 72 часов с момента совершения оплаты по вине Исполнителя, Заказчик имеет право требовать полный возврат уплаченных денежных средств.'
        },
        {
          number: '7.4',
          text: 'В случае совершения платежа несовершеннолетним лицом без согласия законных представителей, обращение о возврате средств направляется законным представителем с предоставлением документов, подтверждающих полномочия и факт оплаты.'
        },
        {
          number: '7.5',
          text: 'Заявки на возврат направляются на электронную почту: support@interworld.fun с указанием номера платежа Robokassa, даты, никнейма и причины обращения. Требование потребителя рассматривается и удовлетворяется в сроки, установленные законодательством Российской Федерации.'
        }
      ]
    },
    {
      id: 8,
      title: '8. Разрешение споров',
      items: [
        {
          number: '8.1',
          text: 'Стороны стремятся урегулировать спор путем переговоров и обмена претензиями. Срок ответа на письменную претензию — 10 рабочих дней.'
        },
        {
          number: '8.2',
          text: 'В случае невозможности достижения согласия спор подлежит рассмотрению в суде в соответствии с действующим законодательством Российской Федерации.'
        }
      ]
    },
    {
      id: 9,
      title: '9. Реквизиты Исполнителя',
      items: [
        {
          number: '',
          text: 'Исполнитель: Сопов Артем Игоревич\nИНН: 780737781518\nСтатус: Плательщик налога на профессиональный доход (НПД)\nЭлектронная почта поддержки: support@interworld.fun\nОфициальный сайт: https://interworld.fun'
        }
      ]
    }
  ];

  return (
    <main className={`container ${styles.publicOffer}`}>
      <div className="container">
        <div style={{marginTop: '1rem'}}>
          <header className={styles.header}>
            <h1 className="title">Публичная оферта</h1>
            <p className={styles.subtitle}>Публичная оферта на оказание цифровых услуг</p>
          </header>

          <div className={styles.sectionsContainer}>
            {sections.map((section) => (
              <div key={section.id} className={`glassCard ${styles.section}`}>
                <h2 className={styles.sectionTitle}>{section.title}</h2>
                <div className={styles.itemsList}>
                  {section.items.map((item, index) => (
                    <div key={index} className={styles.item}>
                      {item.number && (
                        <span className={styles.itemNumber}>{item.number}</span>
                      )}
                      <p className={styles.itemText}>{item.text}</p>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
            <div className={styles.footer}>
            <p className={styles.updateDate}>Дата последнего обновления: 21 июля 2026 г.</p>
          </div>

          <div className={styles.contactsSection}>
            <Contacts />
          </div>

        </div>
      </div>
    </main>
  );
};

export default PublicOffer;
